import { currentBreakpoint } from '../lib/responsive';
import { transitionEndEventName } from '../lib/helper';

const transitionEnd = transitionEndEventName();

export default class ToolTip {

  constructor(el) {

    this.el = el;
    this.wrapper = this.el.querySelector('.tooltip-content');
    this.positionAdjusted = false;
    this.wrapper.addEventListener(transitionEnd, this.onTransitionEnd.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  onTransitionEnd(e) {

    if (this.positionAdjusted || currentBreakpoint !== 'xs') {

      return;
    }
    if (e.propertyName == 'opacity' || e.propertyName == 'visibility') {

      const dimensions = this.wrapper.getBoundingClientRect();
      if (dimensions.right > document.documentElement.clientWidth) {

        const diff = Math.round(dimensions.right - document.documentElement.clientWidth);
        this.wrapper.style.left = -diff + 'px';
      } else if (dimensions.left < 0) {

        this.wrapper.style.left = (-dimensions.left) + 'px';
      }
      this.positionAdjusted = true;
    }
  }

  handleResize(e) {

    this.positionAdjusted = false;
    this.wrapper.style.left = '';
  }

};
